module.exports = __webpack_public_path__ + "static/media/FB.0e3c501e.svg";